import Heading from 'LearningManager/components/Heading';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import CheckBoxCard from 'LearningManager/components/CheckBoxCard';
import { Icon, Input } from 'Components';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

interface OptionsProps {
	id: number;
	title: string;
	desc: string;
}

const options: OptionsProps[] = [
	{
		id: 1,
		title: 'Staff',
		desc: 'All users other than Managers and Leadership team'
	},
	{
		id: 2,
		title: 'Manager',
		desc: 'Department and property managers'
	},
	{
		id: 3,
		title: 'Leadership and IT',
		desc: 'Those overseeing system and strategy'
	}
];

const Role = () => {
	const {
		draft: {
			customSetup: { selectedRoleIds, selectedRolePropertyIds }
		},
		toggleAssignUsersSelection,
		setAssignUsersSelection,
		setAssignUsersPropertyFilter
	} = useStepper();

	const handleCheckboxChange = (id: number, checked: boolean) => {
		if (checked !== selectedRoleIds.includes(id)) {
			toggleAssignUsersSelection('selectedRoleIds', id);
		}
	};

	const handleSelectAll = () => {
		if (selectedRoleIds.length === options.length) {
			setAssignUsersSelection('selectedRoleIds', []);
		} else {
			setAssignUsersSelection(
				'selectedRoleIds',
				options.map((opt) => opt.id)
			);
		}
	};

	const properties = [
		{ id: 1, label: 'Pyramid Hotel' },
		{ id: 2, label: 'Marriott Hotel' },
		{ id: 3, label: 'Grand Plaza' },
		{ id: 4, label: 'Ocean View Resort' }
	];

	const handleChange = (ids: number[]) => {
		setAssignUsersPropertyFilter('selectedRolePropertyIds', ids);
	};

	const isAllSelected = selectedRoleIds.length === options.length;

	return (
		<div id="lms-ca-assign-users-role">
			<div>
				<Heading />
				<div className={styles.filters}>
					<div
						id="lms-ca-au-role-property-filter"
						className={styles.search}
					>
						<div className={styles.selectProp}>Select Property</div>
						<MultiSelectDropdown
							options={properties}
							placeholder="Select option"
							onChange={handleChange}
							defaultSelectedIds={selectedRolePropertyIds}
						/>
					</div>
					<Input.Search
						id="lms-ca-au-role-search"
						className={styles.search}
						placeholder="Search"
						suffix={<Icon type="search" role="img" />}
					/>
				</div>
			</div>
			<div className={styles.header}>
				<Heading
					titleClassName={styles.title}
					title="Select role"
					astrix={true}
				/>
				{options.length > 1 && (
					<div
						id="lms-ca-au-role-select-all"
						className={styles.selectAllBtn}
						onClick={handleSelectAll}
					>
						{isAllSelected ? 'Deselect all' : 'Select all'}
					</div>
				)}
			</div>
			<div id="lms-ca-au-role-list" className={styles.container}>
				{options.map((option) => {
					const isChecked = selectedRoleIds.includes(option.id);
					return (
						<CheckBoxCard
							key={option.id}
							id={option.id}
							htmlId={`lms-ca-au-role-${option.id}`}
							icon={
								<Icon
									type={
										isChecked
											? 'roleOptFilled'
											: 'roleOptIcon'
									}
								/>
							}
							title={option.title}
							desc={option.desc}
							isChecked={isChecked}
							onChange={handleCheckboxChange}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default Role;
